/** @iotv/datamodel should not be dependent on @iotv/payload-definition which exports deviceEnabled types, this aims to infer from class inheritence from DeviceEnabledType */

import { Property, Area, Place, Group, ModelCommon, UserAttributeDefs } from '@iotv/datamodel-core'

type GetUserAttributesFn = () => UserAttributeDefs


type MutateGetUserAttributesInput = {
  clazz: new ([ ...args ]: any) => any
  override: { [ fnName: string ]: Function }
  extend: { [ fnName: string ]: Function }
}
export const mutateGetUserAttributes = ({ clazz, override, extend }: MutateGetUserAttributesInput) => {

  Object.entries(extend).forEach(([ fnName, extendingFn ]) => {
    const original = clazz.prototype.getUserAttributes
    try {
      if (typeof clazz.prototype[ fnName ] === 'function')
        clazz.prototype[ fnName ] = function (...args: any[]) {

          const baseResult = original.apply(this, args)
          const extendResult = extendingFn.apply(this, args)   
          return { ...baseResult, ...extendResult }
        }
    } catch (e: any) {

    }
  })

  Object.entries(override).forEach(([ fnName, overrideFn ]) => {
    const original = clazz.prototype.getUserAttributes
    try {
      if (typeof clazz.prototype[ fnName ] === 'function')
        clazz.prototype[ fnName ] = function (...args: any[]) {
          const result = overrideFn.apply(this, args)
          return result
        }
    } catch (e: any) {

    }
  })



}
